// extracted by mini-css-extract-plugin
export default {"modal":"cancelSubscriptionModal_modal__MMr+x"};